/**
 * Derive avatar initials from a display name.
 *
 * Splits on whitespace, takes the first letter of each word, uppercases, and
 * truncates to `max` characters. Returns '?' for empty or non-string input so
 * callers can render something rather than nothing.
 *
 * @param {string} name - Full display name (e.g. "Alex James", "Marsha A.")
 * @param {number} [max=2] - Maximum number of initials to return
 * @returns {string} - e.g. "AJ", "M", or "?"
 */
export function getInitials(name, max = 2) {
  if (!name || typeof name !== 'string') return '?';
  const initials = name
    .trim()
    .split(/\s+/)
    .map((word) => word[0])
    .filter(Boolean)
    .join('')
    .toUpperCase()
    .slice(0, max);
  return initials || '?';
}
